export const filters_historico_transacoes = "@filters_historico_transacoes";
export const filters_historico_transferencia =
  "@filters_historico_transferencia";
export const filters_historico_ted = "@filters_historico_ted";
export const filters_historico_pix = "@filters_historico_pix";
export const filters_gerenciar_contas = "@filters_gerenciar_contas";
